import { Icon, IconName, type IconProps } from '../Icons';

type AggregationIconProps = Omit<IconProps, 'icon' | 'color'>;

export const AggregationIcon = (props: AggregationIconProps) => (
  <Icon icon={IconName.CommandCmd} color="colors.purple.lighten" {...props} />
);
